import React from 'react';
import * as Mapbox from "react-map-gl/mapbox";
import {FillLayerSpecification, LayerSpecification, LineLayerSpecification, SymbolLayerSpecification} from 'mapbox-gl';
import {MapLayer} from "../../../types/MapLayers";

// Types ----

type SiteLayerProps = {
  source?: string
  enabledLayers: MapLayer[]
}

// Component ----

function SiteLayer({source = '', enabledLayers} : SiteLayerProps) {

  // Filters
  const siteFilter = ["==", "type", "site"]

  // Layout Properties
  const layout: LayerSpecification['layout'] = { visibility: enabledLayers.includes(MapLayer.SITE) ? "visible" : "none" };

  return (
    <>
      <Mapbox.Layer
        type="fill"
        id="ngage-site"
        source={source}
        filter={siteFilter}
        paint={sitePaint}
        layout={layout}
      />

      <Mapbox.Layer
        type="line"
        id="ngage-site-outline"
        source={source}
        filter={siteFilter}
        paint={siteOutlinePaint}
        layout={layout}
      />

      <Mapbox.Layer
        type="symbol"
        id="ngage-site-name"
        source={source}
        filter={siteFilter}
        layout={{...siteNameLayout, ...layout}}
        paint={siteNamePaint}
      />
    </>
  );
}

// Styles ----

const sitePaint: FillLayerSpecification['paint'] = {
  "fill-color": "#9a9a9a",
  "fill-opacity": 0.2,
}

const siteOutlinePaint: LineLayerSpecification['paint'] = {
  "line-color": "#949494",
  "line-width": 2,
}

const siteNameLayout: SymbolLayerSpecification['layout'] = {
  "text-field": ["get", "name"],
  "text-anchor": "center",
}

const siteNamePaint: SymbolLayerSpecification['paint'] = {
  "text-halo-width": 2,
  "text-halo-color": "#FFFFFF",
}

export default SiteLayer;